import { createAction, props } from '@ngrx/store';
import { ProgressBackLink } from 'app/store/project/progresses-back-links/progresses-back-links.reducer';

export const addBackLink = createAction('[Progresses Back Links Store] Add Back Link', props<ProgressBackLink>());
